//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"

export default function QuestionOrderSmall({ questionOrder }) {
  let name = "No name"

  if (questionOrder.question) {
    name = `${questionOrder.question.text} [${questionOrder.question.type}]`
  } else if (questionOrder.questionGroup) {
    name = `${questionOrder.questionGroup.name} [Group]`
  }

  return (
    <div className={myStyles.questionOrderSmall}>
      <div>{name}</div>

      <div>
        <small style={{ color: "gray" }}>
          {questionOrder.question
            ? questionOrder.question.helpText
            : `${questionOrder.questionGroup.questions.length} questions`}
        </small>
      </div>
    </div>
  )
}
